module.exports = __webpack_public_path__ + "img/flow-icon-3.9b5f0ba7.png";